"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.NOTIFICATION_STATUS = void 0;

var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NotificationsContext = _interopRequireDefault(require("./NotificationsContext"));

var _NotifySetter = _interopRequireDefault(require("./NotifySetter"));

var NOTIFICATION_STATUS = {
  DANGER: 'danger',
  WARNING: 'warning',
  SUCCESS: 'success',
  INFO: 'info',
  LOADING: 'loading',
  HIDDEN: 'hidden'
};
exports.NOTIFICATION_STATUS = NOTIFICATION_STATUS;

var NotificationsProvider = function NotificationsProvider(_ref) {
  var position = _ref.position,
      align = _ref.align,
      rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["position", "align"]);

  var _useState = (0, _react.useState)({}),
      notifications = _useState[0],
      setNotifications = _useState[1];

  var closeNotificationById = (0, _react.useCallback)(function (notificationId) {
    if (notifications[notificationId]) {
      var _extends2;

      setNotifications((0, _extends4.default)({}, notifications, (_extends2 = {}, _extends2[notificationId] = (0, _extends4.default)({}, notifications[notificationId], {
        status: NOTIFICATION_STATUS.HIDDEN
      }), _extends2)));
    }
  }, [notifications]);
  var notify = (0, _react.useCallback)(function (notification) {
    var _extends3;

    if (notifications[notification.id] && notifications[notification.id].timeout) {
      clearTimeout(notifications[notification.id].timeout);
    }

    if (notification.status === NOTIFICATION_STATUS.SUCCESS) {
      var autoCloseNotification = function autoCloseNotification() {
        notify((0, _extends4.default)({}, notification, {
          status: NOTIFICATION_STATUS.HIDDEN
        }));
      };

      notification.timeout = setTimeout(autoCloseNotification, 5000);
    }

    setNotifications((0, _extends4.default)({}, notifications, (_extends3 = {}, _extends3[notification.id] = notification, _extends3)));
  }, [notifications]);
  return /*#__PURE__*/_react.default.createElement(_NotificationsContext.default.Provider, {
    value: {
      statusTypes: NOTIFICATION_STATUS,
      notifications: notifications,
      notify: notify,
      align: align,
      position: position,
      closeNotificationById: closeNotificationById
    }
  }, /*#__PURE__*/_react.default.createElement(_NotifySetter.default, rest));
};

NotificationsProvider.propTypes = {
  /** Sets notification position relative to window */
  position: _propTypes.default.oneOf(['top', 'left', 'bottom', 'right']),

  /** Sets notification alignment relative to position */
  align: _propTypes.default.oneOf(['start', 'center', 'end'])
};
NotificationsProvider.defaultProps = {
  position: 'right',
  align: 'start'
};
NotificationsProvider.displayName = 'NotificationsProvider';
var _default = NotificationsProvider;
exports.default = _default;